import { useEffect, useState } from 'react';

/**
 * Consulta de medios reactiva.
 *
 * Se usa para decidir ENTRE COMPONENTES, no para maquetar: lo que es cuestion
 * de estilo se resuelve en CSS. Aqui hace falta porque en movil la captura
 * diaria de ingresos no es la misma tabla mas estrecha, es otra interfaz.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** Ancho por debajo del cual se sirve la interfaz de movil. */
export const MOVIL = '(max-width: 700px)';
